export const parentDomain = (referrer: string) => {
    const matches = referrer.match(/^https?:\/\/([^#/?]+)(?:[#/?]|$)/i)
    if (!matches || !matches[1]) {
        return
    }

    const result = matches[1].match(/[^.]+\.[^.]+$/)
    if (!result) {
        return
    }

    return result[0]
}

export const getDomain = (referrer: string): string | undefined => {
    return parentDomain(referrer)
}
